import axiosClient from './axiosClient';
import { IBaseResponse, IListDataResponse } from '~/utils/interface/base';

// Counts come from the list endpoints' pagination (limit 1), so no rows are downloaded.
const count = async (url: string, params: Record<string, string> = {}) => {
  const resp = await axiosClient.get<IBaseResponse<IListDataResponse<unknown[]>>>(url, {
    params: { page: 1, limit: 1, ...params },
  });
  return resp.data.data.pagination.totalItems;
};

export type MedicalSectionKey =
  | 'medications'
  | 'allergies'
  | 'healthHistory'
  | 'testResults'
  | 'emergencyContacts'
  | 'doctorContacts';

// A failed count is left out (shown as unknown) rather than blanking the whole overview.
export type IMedicalOverview = Partial<Record<MedicalSectionKey, number>>;

const SOURCES: Record<MedicalSectionKey, [string, Record<string, string>?]> = {
  medications: ['medications'],
  allergies: ['medical-records', { type: 'ALLERGY' }],
  healthHistory: ['medical-records', { type: 'HEALTH_HISTORY' }],
  testResults: ['medical-records', { type: 'TEST_RESULT' }],
  emergencyContacts: ['emergency-contacts'],
  doctorContacts: ['doctor-contacts'],
};

export const getMedicalOverview = async (keys: MedicalSectionKey[]): Promise<IMedicalOverview> => {
  const entries = await Promise.all(
    keys.map(async (key) => {
      const [url, params] = SOURCES[key];
      return [key, await count(url, params).catch(() => undefined)] as const;
    })
  );

  return Object.fromEntries(entries.filter(([, value]) => value !== undefined));
};
